import "./Contact.css";
import { useTheme } from "@chakra-ui/react";
import { FaLinkedin, FaGithub } from "react-icons/fa";
import { IconButton } from "@chakra-ui/react";

const Contact = () => {
    const theme = useTheme();
    return (
        <div
            className="contact"
            id="contact"
            style={{
                backgroundColor: theme.colors.secondary,
                color: theme.colors.primary,
            }}
        >
            <h1 className="sectionHeading">Contact</h1>
            <div className="contactContainer">
                <h2
                    className="contactHeading"
                    style={{
                        color: theme.colors.tertiary,
                    }}
                >
                    CONTACT ME
                </h2>
                <p className="email">annafmunro@gmail.com</p>
                <h2
                    className="contactHeading"
                    style={{
                        color: theme.colors.tertiary,
                    }}
                >
                    FOLLOW ME
                </h2>
                <div className="socialContent">
                    <a
                        href="https://linkedin.com/in/anna-frances-munro/"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <IconButton
                            style={{
                                backgroundColor: theme.colors.secondary,
                                color: theme.colors.primary,
                            }}
                            fontSize="3rem"
                            size="lg"
                            aria-label="LinkedIn"
                            icon={<FaLinkedin />}
                            className="landingSocialIcon"
                        />
                    </a>
                    <a
                        href="https://github.com/annafran"
                        target="_blank"
                        rel="noreferrer"
                    >
                        <IconButton
                            style={{
                                backgroundColor: theme.colors.secondary,
                                color: theme.colors.primary,
                            }}
                            fontSize="3rem"
                            size="lg"
                            aria-label="GitHub"
                            icon={<FaGithub />}
                            className="landingSocialIcon"
                        />
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Contact;
